import React from "react";
import { useSortable } from "@dnd-kit/sortable";
import { CSS } from "@dnd-kit/utilities";
import Button from "../../components/Button";
import DotVRIcon from "../../icons/DotVRIcon";

export function SortableItem(props: any) {
  const { ad, handlePreview, handleEdit, handleDelete } = props;
  const { attributes, listeners, setNodeRef, transform, transition } =
    useSortable({ id: ad.id, data: {ad} });

  const style = {
    transform: CSS.Transform.toString(transform),
    transition,
  };

  return (
    <tr
        className="border-b"
      ref={setNodeRef}
      style={style}
      key={ad.id}
    >
      <td  {...attributes}
      {...listeners} className="flex p-2 text-center items-center gap-4">
        <DotVRIcon className="w-4 h-4 mr-2 cursor-move"/>
        {ad.id}
        </td>
      <td className="p-2 text-center">{ad.url}</td>
      <td className="p-2 text-center">{ad.section}</td>
      <td className="p-2 text-center">{ad.order_no}</td>
      <td className="p-2 text-center" onClick={() => handlePreview(ad)}>
        <Button fontSize="small" variant="info">
          Preview ad
        </Button>
      </td>
      <td className="flex w-full p-2 gap-2 justify-center text-white">
        <Button fontSize="small" variant="primary" id="newEdit" onClick={() => handleEdit(ad)}>
          Edit
        </Button>
        <Button fontSize="small" variant="error" id="delete" onClick={() => handleDelete(ad)}>
          Delete
        </Button>
      </td>
    </tr>
  );
}


// import React from 'react';
// import {useSortable} from '@dnd-kit/sortable';
// import {CSS} from '@dnd-kit/utilities';

// export function SortableItem(props: any) {
//   const {
//     attributes,
//     listeners,
//     setNodeRef,
//     transform,
//     transition,
//   } = useSortable({id: props.id});
  
//   const style = {
//     transform: CSS.Transform.toString(transform),
//     transition,
//   };
  
//   return (
//     <tr className='w-full' ref={setNodeRef} style={style} {...attributes} {...listeners}>
//         <td>{props.id}</td>
//         <td>content here</td>
//     </tr>
//   );
// }